var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<a class=\"skip-main\" ng-click=\"$wbSkipToContentCtrl.skipToContent()\" ng-keyup=\"$event.keyCode == 13 ? $wbSkipToContentCtrl.skipToContent() : null\" tabindex=\"0\">Skip to Content</a>";
var id1="javascripts/skip-to-content/skip_to_content.template.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../src/public/javascripts/skip-to-content/skip_to_content.template.html
// module id = 1322
// module chunks = 0